import { apiCallAc } from "..";

export function fetchFonts() {
	return apiCallAc.get(`/dashboard/image/editor/fonts`);
}

export function fetchFontssNext(url) {
	return apiCallAc.get(url);
}
